const Card: React.FC<React.PropsWithChildren<{ className?: string }>> = ({
  children,
  className = "",
}) => (
  <div
    className={`bg-white shadow-md rounded-lg overflow-hidden p-6 ${className}`}
  >
    {children}
  </div>
);

export default Card;
